module.exports = __webpack_public_path__ + "static/052_Gippsland-cad0f6c459f5c1ceaecacf7f6267b076.jpg";